/* VAEN v8 · pages runtime — reveals, counters, material preview */
(function () {
  if (window.__vnP8) return; window.__vnP8 = 1;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    var els = [].slice.call((root || document).querySelectorAll('[data-p8]:not([data-p8-ok])'));
    if (!els.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); count(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }) : null;
    els.forEach(function (el) {
      el.setAttribute('data-p8-ok', '');
      [].forEach.call(el.querySelectorAll('[data-p8-in]'), function (c) { io ? io.observe(c) : c.classList.add('is-in'); });
      if (io && !RM) io.observe(el); else { el.classList.add('is-in'); count(el); }
      if (el.matches('.p8m')) preview(el);
    });
  }
  function count(el) {
    [].forEach.call(el.querySelectorAll('[data-count]:not([data-c-ok])'), function (n) {
      n.setAttribute('data-c-ok', '');
      var to = parseFloat(n.getAttribute('data-count')) || 0, dec = (n.getAttribute('data-count').split('.')[1] || '').length, t0 = performance.now(), D = 1800;
      if (RM) { n.textContent = to.toFixed(dec); return; }
      (function step(t) { var k = Math.min(1, (t - t0) / D); k = 1 - Math.pow(1 - k, 4); n.textContent = (to * k).toFixed(dec); if (k < 1) requestAnimationFrame(step); })(t0);
    });
  }
  function preview(sec) {
    var pv = sec.querySelector('.p8m__pv'); if (!pv || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var imgs = [].slice.call(pv.querySelectorAll('img')), x = 0, y = 0, tx = 0, ty = 0, raf = 0, last = 0;
    function loop() { x += (tx - x) * .14; y += (ty - y) * .14; var r = Math.max(-8, Math.min(8, (tx - x) * .05)); pv.style.setProperty('--x', x + 'px'); pv.style.setProperty('--y', y + 'px'); pv.style.setProperty('--r', r + 'deg'); raf = requestAnimationFrame(loop); }
    [].forEach.call(sec.querySelectorAll('.p8m__r'), function (r, i) {
      r.addEventListener('mouseenter', function (e) { tx = e.clientX; ty = e.clientY; if (!raf) { x = tx; y = ty; loop(); } pv.classList.add('is-on'); imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); }); });
      r.addEventListener('mouseleave', function () { pv.classList.remove('is-on'); setTimeout(function () { if (!pv.classList.contains('is-on')) { cancelAnimationFrame(raf); raf = 0; } }, 500); });
    });
    sec.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
